import { render, staticRenderFns } from "./view-atcc-details.vue?vue&type=template&id=14fe36f0&scoped=true&"
import script from "./view-atcc-details.vue?vue&type=script&lang=js&"
export * from "./view-atcc-details.vue?vue&type=script&lang=js&"
import style0 from "./view-atcc-details.vue?vue&type=style&index=0&id=14fe36f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fe36f0",
  null
  
)

export default component.exports